<div class="responses">
  <div class="header">
    <div
      class="header-text"
      fxLayout="row"
      fxLayoutAlign="start center">
      <i class="icon icon-error"></i>
      <div class="text">{{ 'COMMUNICATIONS.ESCALATED-RESPONSES' | translate }}</div>
    </div>

    <div>
      <topo-icon-item-select
        [selectedUId]="selectedSortItem?.uId"
        [icon]="selectedSortItem?.icon"
        [label]="selectedSortItem?.name"
        itemLabel="name"
        itemIcon="icon"
        [items]="sortItems"
        [isMedium]="true"
        (itemSelected)="onSelectedSortChanged($event)"
      [useTopoIcons]="true"></topo-icon-item-select>
    </div>
  </div>

  @if (responses) {
    <div
      class="body"
      >
      @for (response of responses; track response.massNotificationRecipientUId + '_' + response.channelUId; let i = $index) {
        <div>
          <div class="response-card">
            @if (response?.name) {
              <div
                class="name"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="8px">
                <topo-avatar
                  [name]="response?.name"
                [showName]="false"></topo-avatar>
                <div
                  class="link"
                  (click)="onRecipientClick(response)">
                  {{ response?.name }}
                </div>
              </div>
            }
            @if (response?.responseText) {
              <div
                class="response"
                >
                {{ response?.responseText }}
              </div>
            }
            @if (response.confirmationOptionsUId) {
              <div
                class="confirmation-text-display"
                [ngStyle]="{ 'background-color': getConfirmationColor(response) }">
                {{ getConfirmationText(response) }}
              </div>
            }
            <div
              class="address"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px">
              <i class="icon {{ getChannelIcon(response?.channelUId) }}"></i>
              <div class="text">{{ response?.address }}</div>
            </div>
            <div
              class="time"
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <div>{{ getResponseTime(response?.responseTime) }}</div>
              <div>{{ getResponseTimePassed(response?.responseTime) }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
